import { useState, useEffect } from 'react';
import { type SupportFAQ, googleSheetsService } from '../services/googleSheets';

export interface UseSupportReturn {
  supportData: SupportFAQ[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useSupport(): UseSupportReturn {
  const [supportData, setSupportData] = useState<SupportFAQ[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSupportData = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await googleSheetsService.getSupportFAQ();
      setSupportData(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar dados de suporte');
      console.error('Erro ao carregar dados de suporte:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSupportData();
  }, []);

  return {
    supportData,
    loading,
    error,
    refetch: fetchSupportData
  };
}